export const accountRouters = [
  {
    path: "/account",
    name: "Account",
    component: () => System.import("@/components/vcponlineok/customer-user/account/account-view.vue"),
    children: [
      {
        path: "confirm-email",
        name: "EmailConfirmation",
        permission: "",
        meta: {
          title: "EmailConfirmation",
          isPublic: true,
        },
        component: () => System.import("@/components/vcponlineok/customer-user/account/email-confirmation.vue"),
      },

      {
        path: "emailconfirmation",
        name: "EmailConfirmationFromMvcAdmin",
        permission: "",
        meta: {
          title: "EmailConfirmation",
          isPublic: true,
        },
        component: () => System.import("@/components/vcponlineok/customer-user/account/email-confirmation.vue"),
      },
      {
        path: "reset-password",
        name: "ResetPassword",
        permission: "",
        meta: {
          title: "ResetPassword",
          isPublic: true,
        },
        component: () => System.import("@/components/vcponlineok/customer-user/account/reset-password.vue"),
      },
      {
        path: "forget-password",
        name: "ForgetPassword",
        permission: "",
        meta: {
          title: "ForgetPassword",
          isPublic: true,
        },
        component: () => System.import("views/vcponlineok/login/forget-password.vue"),
      },

      {
        path: "create-account",
        name: "CreateAccount",
        permission: "",
        meta: {
          title: "CreateAnAccount",
          isPublic: true,
        },
        component: () => System.import("views/vcponlineok/login/login.vue"),
      },

      
    ],
  },
]
